import { render, staticRenderFns } from "./ApproveStatusTag.vue?vue&type=template&id=0d22f5c6&scoped=true"
import script from "./ApproveStatusTag.vue?vue&type=script&lang=js"
export * from "./ApproveStatusTag.vue?vue&type=script&lang=js"
import style0 from "./ApproveStatusTag.vue?vue&type=style&index=0&id=0d22f5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d22f5c6",
  null
  
)

export default component.exports